import Header from './header';
import Footer from './footer';
const Wizard = {
  Header,
  Footer
};
export default Wizard;
//# sourceMappingURL=index.js.map